import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import FeaturesStrip from "./components/FeaturesStrip";
import Footer from "./components/Footer";
import LoginModal from "./components/LoginModal";
import LoginPage from "./pages/LoginPage";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ClientDashboard from "./pages/ClientDashboard";
import AdminDashboard from "./pages/AdminDashboard";

const Home = ({ openLogin }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // If user is already connected and lands on home → keep them on landing,
  // but the Access button will route them to their dashboard directly.
  const handleAccess = () => {
    if (user) {
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } else {
      openLogin();
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header onAccessClick={handleAccess} />
      <Hero />
      <FeaturesStrip />
      <Footer />
    </div>
  );
};

const ProtectedRoute = ({ role, children }) => {
  const { user, initializing } = useAuth();
  if (initializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-10 h-10 border-4 border-[#007EAE]/20 border-t-[#007EAE] rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  return children;
};

const AppInner = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute role="client">
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppInner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
